import { render, staticRenderFns } from "./FilterSummaryCategoryRoots.vue?vue&type=template&id=d5e01b3a&"
import script from "./FilterSummaryCategoryRoots.vue?vue&type=script&lang=js&"
export * from "./FilterSummaryCategoryRoots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports